import { render, staticRenderFns } from "./TaskBoard.html?vue&type=template&id=4d379d18&scoped=true&external"
import script from "./TaskBoard.vue?vue&type=script&lang=js"
export * from "./TaskBoard.vue?vue&type=script&lang=js"
import style0 from "./TaskBoard.scss?vue&type=style&index=0&id=4d379d18&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d379d18",
  null
  
)

export default component.exports